import { theme } from 'shared/styles/theme';

import { Box, BoxProps } from './Box';

import styled from '@emotion/styled';

export const Paper = styled(Box)<BoxProps>({
  borderRadius: theme.borderRadius,
  border: '2px solid #000',
});
